// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { collection, doc, getDoc, addDoc, firestore } from '../../../firebase';
// import { Button, TextField, Typography, Paper } from '@mui/material';
// import axios from 'axios';
// import { auth } from '../../../firebase';

// function RaiseComplaintForm() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [item, setItem] = useState(null);
//   const [issue, setIssue] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');
//   const [complaintId, setComplaintId] = useState('');
//   const [status, setStatus] = useState('Open');

//   /*
//     Fetches item details from Firestore based on the item ID passed in the URL.
//     This function runs when the component mounts or when the 'id' changes.
//    */
//   useEffect(() => {
//     const fetchItem = async () => {
//       const itemDoc = doc(collection(firestore, 'ItemMaster'), id);
//       const itemSnapshot = await getDoc(itemDoc);
//       if (itemSnapshot.exists()) {
//         setItem(itemSnapshot.data());
//       } else {
//         console.error('No such document!');
//       }
//       setLoading(false);
//     };

//     fetchItem();
//   }, [id]);

//   /*
//    Handles form submission for raising a complaint.
//    Validates if the user is authenticated, then creates a complaint document in Firestore.
//    If successful, sends a confirmation email with complaint details.
//    @param {Object} e - The event object from form submission.
//    */
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMessage('');
//     setError('');

//     try {
//       const currentUser = auth.currentUser;
//       if (!currentUser) throw new Error('User not authenticated');

//       const complaintsCollection = collection(firestore, 'Complaints');
//       const docRef = await addDoc(complaintsCollection, {
//         itemId: id,
//         issueDescription: issue,
//         status: status,
//         userId: currentUser.uid,
//         timestamp: new Date(),
//       });
//       setComplaintId(docRef.id);
//       setMessage('Complaint raised successfully.');
//       setIssue('');
//       setStatus('Open');

//       const email = item?.shopEmail;
//       const apiKey = 'qwertyuiop'; // Replace with your actual API key
//       const itemMake = item?.itemMake || 'N/A';
//       const itemModel = item?.model || 'N/A';
//       const purchaseDate = item?.purchaseDate || 'N/A';
//       const warrantyExpiryDate = item?.warrantyExpiryDate || 'N/A';

//       await sendOrderConfirmationEmail(email, apiKey, docRef.id, itemMake, itemModel, purchaseDate, warrantyExpiryDate, issue);

//     } catch (err) {
//       console.error('Error raising complaint:', err);
//       setError('Failed to raise complaint. Please try again.');
//     }
//   };

//   /*
//    Sends an error email when there is a failure in the process (e.g., invalid API key).
//    @param {string} email - The recipient's email address.
//    @param {string} apiKey - API key for the email service.
//    @param {string} complaintId - ID of the complaint associated with the error.
//    @param {string} errorMessage - The error message to include in the email.
//    */
//   const sendOrderErrorEmail = async (email, apiKey, complaintId, errorMessage) => {
//     const jsonPayload = {
//       email,
//       subject: `Error - ${complaintId}`,
//       textbody: `An error occurred: ${errorMessage}.`,
//       htmlbody: `
//         <div style="font-family: Arial, sans-serif; color: #333;">
//           <h2 style="color: #FF5722;">Error Notification</h2>
//           <p><strong>Complaint ID:</strong> ${complaintId}</p>
//           <p><strong>Error Message:</strong> ${errorMessage}</p>
//         </div>`,
//       apiKey,
//     };

//     const formData = new FormData();
//     formData.append('jsonPayload', JSON.stringify(jsonPayload));

//     try {
//       const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       if (response.status === 200) {
//         console.log('Error email sent successfully!');
//       } else {
//         console.error('Error sending error email.');
//       }
//     } catch (error) {
//       console.error('Error sending error email:', error);
//     }
//   };

//   /*
//    Sends an order confirmation email after a complaint is successfully raised.
//    If there's an error (e.g., invalid API key), it sends an error email.
//    @param {string} email - The recipient's email address.
//    @param {string} apiKey - API key for the email service.
//    @param {string} complaintId - ID of the complaint.
//    @param {string} itemMake - Make of the item.
//    @param {string} Model - Model of the item.
//    @param {string} purchaseDate - Purchase date of the item.
//    @param {string} warrantyExpiryDate - Warranty expiry date of the item.
//    @param {string} issue - Issue description of the complaint.
//    @param {string} imageUrl - Optional image URL for the item.
//    */
//   const sendOrderConfirmationEmail = async (email, apiKey, complaintId, itemMake, Model, purchaseDate, warrantyExpiryDate, issue, imageUrl) => {
//     const jsonPayload = {
//       email,
//       subject: `Complaint - ${complaintId}`,
//       textbody: `A complaint is raised. Complaint id is ${complaintId}.`,
//       htmlbody: `
//         <div style="font-family: Arial, sans-serif; color: #333;">
//           <h2 style="color: #4CAF50;">Item Details:</h2>
//           <p>Item make: <strong>${itemMake}</strong>.</p>
//           <p><strong>Item Model:</strong> ${Model}</p>
//           <p><strong>Purchase Date:</strong> ${purchaseDate}</p>
//           <p><strong>Warranty Expiry Date:</strong> ${warrantyExpiryDate}</p>
//           <h2>Issue Description:</h2>
//           <p><strong>${issue}</strong>.</p>
//            ${imageUrl ? `<img src="${imageUrl}" alt="Item Image" style="max-width: 100%; height: auto;"/>` : ''}
//         </div>`,
//       apiKey,
//     };

//     const formData = new FormData();
//     formData.append('jsonPayload', JSON.stringify(jsonPayload));

//     try {
//       const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       if (response.status === 200) {
//         return 'Email sent successfully!';
//       } else {
//         await sendOrderErrorEmail(email, apiKey, complaintId, 'Error sending confirmation email');
//         return 'Error sending email.';
//       }
//     } catch (error) {
//       if (error.response && error.response.status === 403) {
//         await sendOrderErrorEmail(email, apiKey, complaintId, 'Invalid API key');
//         return 'Invalid API key';
//       } else {
//         await sendOrderErrorEmail(email, apiKey, complaintId, 'Error sending confirmation email');
//         return 'Error sending email.';
//       }
//     }
//   };

//   if (loading) return <p>Loading...</p>;

//   return (
//     <Paper style={{ padding: '20px', maxWidth: '600px', margin: 'auto', marginTop: '50px',
//       boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', border: '1px solid rgba(0, 0, 0, 0.12)',
//       borderRadius: '8px' }}>
//       <Typography variant="h6">Raise a Complaint</Typography>
//       {item && (
//         <div>
//           <Typography variant="subtitle1">Item Details:</Typography>
//           <Typography><strong>Make:</strong> {item.itemMake}</Typography>
//           <Typography><strong>Model:</strong> {item.model}</Typography>
//           <Typography><strong>Purchase Date:</strong> {item.purchaseDate}</Typography>
//           <Typography><strong>Warranty Expiry Date:</strong> {item.warrantyExpiryDate}</Typography>
//           {item.imageUrl && (
//             <div style={{ marginTop: '20px' }}>
//               <Typography variant="subtitle1">Item Image:</Typography>
//               <img src={item.imageUrl} alt="Item" style={{ maxWidth: '100%', height: 'auto' }} />
//             </div>
//           )}
//         </div>
//       )}
//       {!message && !error && (
//         <form onSubmit={handleSubmit}>
//           <TextField
//             label="Issue Description"
//             multiline
//             rows={4}
//             fullWidth
//             value={issue}
//             onChange={(e) => setIssue(e.target.value)}
//             required
//             margin="normal"
//           />
//           <Button type="submit" variant="contained" color="primary" style={{ marginTop: '20px' }}>
//             Submit Complaint
//           </Button>
//         </form>
//       )}
//       {message && (
//         <div style={{ marginTop: '20px' }}>
//           <Typography variant="body1" color="green">
//             {message}
//           </Typography>
//           {complaintId && (
//             <Typography variant="body2" color="textSecondary">
//               Complaint ID: {complaintId}
//             </Typography>
//           )}
//         </div>
//       )}
//       {error && (
//         <Typography variant="body1" color="red" style={{ marginTop: '20px' }}>
//           {error}
//         </Typography>
//       )}
//       <Button
//         variant="contained"
//         color="primary"
//         style={{ marginTop: '20px' }}
//         onClick={() => navigate('/warranty_list')}
//       >
//         Back to Warranty List
//       </Button>
//     </Paper>
//   );
// }

// export default RaiseComplaintForm;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  collection,
  doc,
  getDoc,
  addDoc,
  firestore,
  getDocs,
  query,
  where,
} from "../../../firebase";
import { Button, TextField, Typography, Paper } from "@mui/material";
import axios from "axios";
import { auth } from "../../../firebase";

function RaiseComplaintForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [issue, setIssue] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [complaintId, setComplaintId] = useState("");
  const [status, setStatus] = useState("Open");
  const [profileRole, setProfileRole] = useState("");
  const [profileTenantId, setProfileTenantId] = useState("");

  const ORG_OPERATOR_ROLES = [
    "organisation_operator",
    "OU User",
    "OU Operator",
    "Operator",
    "User",
  ];

  // Fetch item details from Firestore
  useEffect(() => {
    const fetchItem = async () => {
      const currentUser = auth.currentUser;
      if (!currentUser?.uid) {
        setError("Please sign in to raise a complaint.");
        setLoading(false);
        return;
      }

      const itemDoc = doc(collection(firestore, "ItemMaster"), id);
      const itemSnapshot = await getDoc(itemDoc);
      if (itemSnapshot.exists()) {
        const itemData = itemSnapshot.data();
        const currentRole = (sessionStorage.getItem("userRole") || "").toLowerCase();

        if (currentRole === "customer" && itemData.userId && itemData.userId !== currentUser.uid) {
          setError("Access denied. You can only raise complaints for your own items.");
          setItem(null);
        } else {
          setItem(itemData);
        }
      } else {
        console.error("No such document!");
      }
      setLoading(false);
    };

    fetchItem();
  }, [id]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const currentUser = auth.currentUser;
        if (!currentUser?.email) return;
        const q = query(
          collection(firestore, "UserProfileMaster"),
          where("email", "==", currentUser.email)
        );
        const snap = await getDocs(q);
        if (!snap.empty) {
          const data = snap.docs[0].data();
          setProfileRole(data.role || sessionStorage.getItem("userRole") || "");
          setProfileTenantId(data.tenantId || data.tenantid || sessionStorage.getItem("tenantId") || "");
        } else {
          setProfileRole(sessionStorage.getItem("userRole") || "");
          setProfileTenantId(sessionStorage.getItem("tenantId") || "");
        }
      } catch (profileError) {
        console.error("Error fetching profile for complaint:", profileError);
      }
    };

    fetchProfile();
  }, []);

  // Handle complaint submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("User not authenticated");

      const currentRole = (profileRole || sessionStorage.getItem("userRole") || "").toLowerCase();
      if (currentRole === "customer" && item?.userId && item.userId !== currentUser.uid) {
        throw new Error("Access denied. You can only raise complaints for your own items.");
      }

      const complaintsCollection = collection(firestore, "Complaints");
      const effectiveRole = profileRole || sessionStorage.getItem("userRole") || "";
      const effectiveTenantId =
        profileTenantId || sessionStorage.getItem("tenantId") || item?.tenantId || null;
      const isOrganisationComplaint = ORG_OPERATOR_ROLES.includes(effectiveRole);

      const docRef = await addDoc(complaintsCollection, {
        itemId: id,
        issueDescription: issue,
        status: status,
        userId: currentUser.uid,
        userEmail: currentUser.email,
        facilityName: item?.facilityName || null,
        branchName: item?.branchName || null,
        facilityRegion: item?.facilityRegion || null,
        facilityPhoneNumber: item?.facilityPhoneNumber || null,
        facilityEmail: item?.facilityEmail || null,
        raisedByRole: effectiveRole || "customer",
        tenantId: effectiveTenantId,
        isOrganisationComplaint,
        timestamp: new Date(),
      });

      setComplaintId(docRef.id);
      setMessage("Complaint raised successfully.");
      setIssue("");
      setStatus("Open");

      const email = item?.facilityEmail;
      const apiKey = "qwertyuiop"; // Replace with your actual API key
      const itemMake = item?.itemMake || "N/A";
      const itemModel = item?.model || "N/A";
      const purchaseDate = item?.purchaseDate || "N/A";
      const warrantyExpiryDate = item?.warrantyExpiryDate || "N/A";

      await sendOrderConfirmationEmail(
        email,
        apiKey,
        docRef.id,
        itemMake,
        itemModel,
        purchaseDate,
        warrantyExpiryDate,
        issue,
        currentUser.email // 👈 Pass customer email to email body
      );
    } catch (err) {
      console.error("Error raising complaint:", err);
      setError("Failed to raise complaint. Please try again.");
    }
  };

  // Sends an error email
  const sendOrderErrorEmail = async (
    email,
    apiKey,
    complaintId,
    errorMessage
  ) => {
    const jsonPayload = {
      email,
      subject: `Error - ${complaintId}`,
      textbody: `An error occurred: ${errorMessage}.`,
      htmlbody: `
        <div style="font-family: Arial, sans-serif; color: #333;">
          <h2 style="color: #FF5722;">Error Notification</h2>
          <p><strong>Complaint ID:</strong> ${complaintId}</p>
          <p><strong>Error Message:</strong> ${errorMessage}</p>
        </div>`,
      apiKey,
    };

    const formData = new FormData();
    formData.append("jsonPayload", JSON.stringify(jsonPayload));

    try {
      const response = await axios.post(
        "https://email-a306.onrender.com/send-email",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status === 200) {
        console.log("Error email sent successfully!");
      } else {
        console.error("Error sending error email.");
      }
    } catch (error) {
      console.error("Error sending error email:", error);
    }
  };

  // Sends order confirmation email
  const sendOrderConfirmationEmail = async (
    email,
    apiKey,
    complaintId,
    itemMake,
    Model,
    purchaseDate,
    warrantyExpiryDate,
    issue,
    customerEmail,
    imageUrl
  ) => {
    const jsonPayload = {
      email,
      subject: `Complaint - ${complaintId}`,
      textbody: `A complaint has been raised. Complaint ID: ${complaintId}.`,
      htmlbody: `
        <div style="font-family: Arial, sans-serif; color: #333;">
          <h2 style="color: #4CAF50;">Item Details:</h2>
          <p><strong>Item Make:</strong> ${itemMake}</p>
          <p><strong>Item Model:</strong> ${Model}</p>
          <p><strong>Purchase Date:</strong> ${purchaseDate}</p>
          <p><strong>Warranty Expiry Date:</strong> ${warrantyExpiryDate}</p>
          <h2>Issue Description:</h2>
          <p><strong>${issue}</strong></p>
          <p><strong>Raised By:</strong> ${customerEmail}</p>
          ${
            imageUrl
              ? `<img src="${imageUrl}" alt="Item Image" style="max-width: 100%; height: auto;"/>`
              : ""
          }
        </div>`,
      apiKey,
    };

    const formData = new FormData();
    formData.append("jsonPayload", JSON.stringify(jsonPayload));

    try {
      const response = await axios.post(
        "https://email-a306.onrender.com/send-email",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status === 200) {
        return "Email sent successfully!";
      } else {
        await sendOrderErrorEmail(
          email,
          apiKey,
          complaintId,
          "Error sending confirmation email"
        );
        return "Error sending email.";
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        await sendOrderErrorEmail(
          email,
          apiKey,
          complaintId,
          "Invalid API key"
        );
        return "Invalid API key";
      } else {
        await sendOrderErrorEmail(
          email,
          apiKey,
          complaintId,
          "Error sending confirmation email"
        );
        return "Error sending email.";
      }
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <Paper
      style={{
        padding: "20px",
        maxWidth: "600px",
        margin: "auto",
        marginTop: "50px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: "8px",
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
        Raise a Complaint
      </Typography>

      {item && (
        <div>
          <Typography variant="subtitle1">Item Details:</Typography>
          <Typography>
            <strong>Product Name:</strong> {item.productName || "N/A"}
          </Typography>
          <Typography>
            <strong>Model:</strong> {item.model}
          </Typography>
          <Typography>
            <strong>Purchase Date:</strong> {item.purchaseDate}
          </Typography>
          <Typography>
            <strong>Warranty Expiry Date:</strong> {item.warrantyExpiryDate}
          </Typography>
          <Typography>
            <strong>Facility Name:</strong> {item.facilityName || "N/A"}
          </Typography>
          <Typography>
            <strong>Branch Name:</strong> {item.branchName || "N/A"}
          </Typography>
          <Typography>
            <strong>Region:</strong> {item.facilityRegion || "N/A"}
          </Typography>
          <Typography>
            <strong>Admin Phone Number:</strong> {item.facilityPhoneNumber || "N/A"}
          </Typography>
          <Typography>
            <strong>Admin Email:</strong> {item.facilityEmail || "N/A"}
          </Typography>
          {item.imageUrl && (
            <div style={{ marginTop: "20px" }}>
              <Typography variant="subtitle1">Item Image:</Typography>
              <img
                src={item.imageUrl}
                alt="Item"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </div>
          )}
        </div>
      )}

      {!message && !error && (
        <form onSubmit={handleSubmit}>
          <TextField
            label="Issue Description"
            multiline
            rows={4}
            fullWidth
            value={issue}
            onChange={(e) => setIssue(e.target.value)}
            required
            margin="normal"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ marginTop: "20px" }}
          >
            Submit Complaint
          </Button>
        </form>
      )}

      {message && (
        <div style={{ marginTop: "20px" }}>
          <Typography variant="body1" color="green">
            {message}
          </Typography>
          {complaintId && (
            <Typography variant="body2" color="textSecondary">
              Complaint ID: {complaintId}
            </Typography>
          )}
        </div>
      )}

      {error && (
        <Typography variant="body1" color="red" style={{ marginTop: "20px" }}>
          {error}
        </Typography>
      )}

      <Button
        variant="contained"
        color="primary"
        style={{ marginTop: "20px" }}
        onClick={() => navigate("/warranty_list")}
      >
        Back to Warranty List
      </Button>
    </Paper>
  );
}

export default RaiseComplaintForm;
